import { Dispatch } from 'redux';
import { AppState } from 'state/reducer';
import { fetchWithState } from 'utils/fetch';

export const submitRatingSurvey =
  (content: string) => async (dispatch: Dispatch, getState: () => AppState) => {
    const participantExternalKey = getState().notifications?.participant?.key;
    if (participantExternalKey) {
      await fetchWithState(dispatch, getState)('surveys', {
        method: 'POST',
        body: JSON.stringify({
          participantExternalKey,
          content,
        }),
        headers: { 'Content-Type': 'application/json' },
      });
    }
  };

export const submitSurveyFeedback =
  (content: string) => async (dispatch: Dispatch, getState: () => AppState) => {
    const participantExternalKey = getState().notifications?.participant?.key;
    if (participantExternalKey) {
      fetchWithState(dispatch, getState)('surveys', {
        method: 'POST',
        body: JSON.stringify({
          participantExternalKey,
          content,
        }),
        headers: { 'Content-Type': 'application/json' },
      });
    }
  };

export const submitSmartResponse =
  (content: string) => async (dispatch: Dispatch, getState: () => AppState) => {
    const participantExternalKey = getState().notifications?.participant?.key;
    if (participantExternalKey) {
      fetchWithState(dispatch, getState)('smart-responses', {
        method: 'POST',
        body: JSON.stringify({
          participantExternalKey,
          content,
        }),
        headers: { 'Content-Type': 'application/json' },
      });
    }
  };
